// use this to show download links for selected files

import React, { useEffect } from "react";
import ReactTable from "react-table";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import auth from "../../../Auth";

import { GPAP_BUTTON_LIGHT } from "../../../../gpap-lib/Button_Collection";

import { file_download2 } from "../../../apis";

const config = window.config;

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     maxWidth: "100%",
//     maxHeight: "300px",
//     overflowY: "auto",
//     backgroundColor: theme.palette.background.paper,
//   },
//   formControl: {
//     margin: "30px",
//     width: "30%",
//   },
// }));

export default function ShowDownloadLinks(props) {
  //columns for react-table
  const headers = [
    { label: "File ID", key: "experiment" },
    { label: "Dataset ID", key: "datasetID" },
    { label: "File Name", key: "FileName" },
    { label: "File Version", key: "FileVersion" },
    { label: "Url", key: "url" },
    { label: "", key: "copy" },
    // { label: "Current Visibility", key: "currentVisibility" },
    // { label: "Current Groups", key: "currentGroups" },
  ];

  let actionSelected = "share with groups";
  if (props.action !== "shareWithGroups") {
    actionSelected = "unshare with groups";
  }

  let columns = [];
  for (let header of headers) {
    let col = {
      Header: header.label,
      accessor: header.key,
      minWidth: 20,
      maxWidth: 100,
    };
    if (header.label === "Url") {
      col.Cell = (e) => {
        return e.value == "download forbidden" ? (
          <div style={{ color: "red" }}>
            <b>{e.value}</b>
          </div>
        ) : (
          <a href={e.value}> {e.value} </a>
        );
      };
    }
    if (header.key === "copy") {
      
      col.Cell = (e) => {
        
        return e.row.url == "download forbidden" ? null : (
          <Button
            color="primary"
            onClick={() => {
              navigator.clipboard.writeText(e.row.url);
            }}
          >
            Copy url
          </Button>
        );
      };
    }
    columns.push(col);
  }

  const [open, setOpen] = React.useState(false);
  let [data, setData] = React.useState({});

  useEffect(() => {
    if (open) {
      (async () => {
        const urlsMapping = await getUrls();
        const rows = getDataTable(urlsMapping);
        setData(rows);
      })();
    }
  }, [open]);

  const getUrls = async () => {
    const selection = props.selected;

    let data = [];
    selection.forEach((row) => {
      data.push(row.id);
    });

    const res = await file_download2(
      auth.getToken(),
      config.api_endpoint,
      JSON.stringify({ file_ids: data })
    );
    const urls = await res.json();
    return urls.presignedUrls;
  };

  const getDataTable = (urlsMapping) => {
    //Build data to render on react-table
    let data = [];

    for (let experiment of Object.entries(props.selected)) {
      data.push({
        experiment: experiment[1].id,
        datasetID: experiment[1].dataset_id,
        FileName: experiment[1].name,
        FileVersion: experiment[1].version,
        url: urlsMapping[experiment[1].id],
        copy: "btn->copy url to the clipboard",
      });
    }
    return data;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <GPAP_BUTTON_LIGHT
        color="primary"
        onClick={handleClickOpen}
        data-cy={"download-files"}
      >
        Download Files
      </GPAP_BUTTON_LIGHT>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Download Links"}</DialogTitle>
        <DialogContent>
          {data.length === props.selected.length ? (
            <ReactTable
              data={data}
              filterable
              columns={columns}
              defaultPageSize={data.length}
              pageSizeOptions={[100, 200, 300]}
              className="-striped -highlight"
            />
          ) : (
            <div>generating download urls...</div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Not now
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
